<template>
   <div class="img_txt_box" @click.stop="">
        <div class="close-btn" @click.stop="closeImgs"></div>
       <div class="img_txt_box_left">
           <div class="img_txt_box_left_txt">
               <h3>{{pluginJson.name}}</h3>
               <!-- 之后用富文本 -->
             <div class="img_txt_box_left_container">
               <vue-scroll>
                 <div class="p-box" v-html="util.fixIntro(pluginJson.description)"></div>
               </vue-scroll>
             </div>
           </div>
       </div>

       <div class="img_txt_box_right swiper-container">
          <div class="swiper-wrapper">
              <div v-for="(plan, index) in pluginJson.plans" :key="index" class="swiper-slide img_txt_box_right_container">
                  <img :src="plan.planUrl" alt="">
              </div>
           </div>
          <div class="swiper-pagination"></div>
          <div class="swiper-button-next"></div>
          <div class="swiper-button-prev"></div>
       </div>
    </div>
</template>

<script>
export default {
  name: 'imgText',
  props: {
    pluginJson: {
      type: Object,
      default: function () {
        return null
      }
    },
    pluginIndex: {
      type: String
    }
  },
  data () {
    return {
      swiper: null
    }
  },
  watch: {

  },
  mounted () {
    let index = Number(this.pluginIndex) - 1
    this.swiper = new window.Swiper('.swiper-container', {
      direction: 'vertical',
      pagination: '.swiper-pagination',
      slidesPerView: 1.6,
      centeredSlides: true,
      paginationClickable: true,
      mousewheelControl: true,
      prevButton: '.swiper-button-prev',
      nextButton: '.swiper-button-next',
      onInit: function (swiper) {
        swiper.slideTo(index, 500, false)
      }
    })
  },
  methods: {
    closeImgs () {
      this.$emit('closeDialog', 'imgsTextShow')
    }
  }
}
</script>

<style lang="scss">
  @function rem($px) {
    @return $px * (1/40) * 1rem;
  }

    .img_txt_box {
        position: relative;
        width: rem(960);
        height: rem(570);
        margin: rem(120) auto;
        background: rgba(25, 35, 70, 0.8);
        box-shadow: 0px rem(12) rem(12) 0px rgba(30, 46, 79, 0.5);
        border-radius: rem(12);
        display: flex;
        border: 1px solid #FFE1BE;

        .close-btn {
            position: absolute !important;
            right: rem(10) !important;
            top: rem(10) !important;
        }

        .img_txt_box_left {
            width: rem(340);
            height: 100%;
            background: #192346;
          margin-left: rem(40);

            .img_txt_box_left_txt {
                width: rem(340);
                font-size: rem(12);
                font-weight: 300;
                color: #FFE1BE;
                line-height: rem(20);

                .img_txt_box_left_container {
                    height: rem(400);
                }
                .p-box{
                  margin: 0 rem(20);
                }

                p {
                    font-size: rem(12);
                    font-weight: 300;
                    color: #FFE1BE;
                    line-height: rem(20);
                  text-indent: 2em;
                  text-align: justify;
                }

                h3 {
                    font-size: rem(24);
                    color: #FFE1BE;
                    line-height: rem(20);
                  margin-left: rem(20);
                    margin-bottom: rem(20);
                    font-weight: 300;
                    margin-top: rem(60);
                }
            }
        }

        .img_txt_box_right {
            width: rem(580);
            height: rem(570);
            margin: 0 0 0 rem(10);
            display: flex;
            justify-content: center;
            align-items: center;

          .swiper-pagination-bullet{
            background: #ffffff;
            opacity: 1;
          }
          .swiper-pagination-bullet-active{
            background: #FFE1BE;
          }

            .swiper-pagination-bullet {
                width: rem(6);
                height: rem(6);
            }

            .swiper-pagination-bullets {
                right: rem(38);

            }

            .swiper-button-next {
                background-image : url('../assets/img/marker/next_btn.png');
                width:rem(24);
                height: rem(24);
                background-size: rem(24) rem(24);
                right: rem(30);
                top: 70%;
            }

            .swiper-button-prev {
                background-image : url('../assets/img/marker/pre_btn.png');
                width:rem(24);
                height: rem(24);
                background-size: rem(24) rem(24);
                left: auto;
                right: rem(30);
                top: 30%;
            }

            .img_txt_box_right_container {
                width: rem(500);
                height: rem(369);
                display: flex;
                justify-content: center;
                align-items: center;

                img {
                  width: rem(500);
                  height: rem(285);
                }

            }
        }

    }

</style>
